import { EntityLinks, Goal, LimitKeys } from '@griply/types';
import { countGoalsTowardLimit } from '@griply/utils';
import { useMemo } from 'react';

import {
  usePremiumFeatureAllowed,
  UsePremiumFeatureAllowedOptions,
} from './use-premium-feature-allowed';

export type UseCreateSubGoalAllowedOptions = UsePremiumFeatureAllowedOptions & {
  goals: Goal[];
  links?: EntityLinks;
};

export const useCreateSubGoalAllowed = ({
  goals,
  links,
  user,
  today,
}: UseCreateSubGoalAllowedOptions) => {
  const total = useMemo(
    () => countGoalsTowardLimit(goals, LimitKeys.SubGoals, links),
    [goals, links],
  );

  // Inline would be a fresh object each render, which defeats the memo inside usePremiumFeatureAllowed.
  const limitOptions = useMemo(() => ({ totalUncompleted: total }), [total]);

  const { allowed, enforced, limit } = usePremiumFeatureAllowed(
    LimitKeys.SubGoals,
    limitOptions,
    { user, today },
  );

  return { allowed, enforced, limit, total };
};
